<template>
  <div class="block">
    <!-- <div class="title">作品列表</div> -->

    <div id="tab">
      <!-- <div class="tab-btn">活跃数据</div> -->
      <!-- <div
        :class="[tabLabel == 1 ? 'tab-btn active' : 'tab-btn']"
        @click="changeTab(1)"
      >
        活跃数据
      </div> -->
      <!-- <div class="list-border"></div>
      <div
        :class="[tabLabel == 2 ? 'tab-income active' : 'tab-income']"
        @click="changeTab(2)"
      >
        收入数据
      </div> -->
    </div>
    <!-- 活跃数据 -->
    <div class="work-wrap" v-if="tabLabel == 1">
      <div class="date-box">
        <div class="data-filter">
          <span class="mgr25">选择日期</span>
          <el-date-picker
            v-model="tableDate"
            type="daterange"
            align="left"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            unlink-panels
            range-separator="~"
            :picker-options="pickerOptions"
            value-format="timestamp"
            @change="DateChange"
          >
          </el-date-picker>
          <el-button
            @click="BtnClicked"
            :class="[brighten ? 'active search_btn' : 'search_btn']"
            type="info"
            >查找</el-button
          >
        </div>
        <div class="date-wrap">
          <el-radio-group
            v-model="dayNum"
            style="margin-bottom: 30px"
            @change="changeDate"
          >
            <el-radio-button label="7">7天</el-radio-button>
            <el-radio-button label="30">30天</el-radio-button>
            <el-radio-button label="90">90天</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="sort-wrap">
        <span class="sort-box">
          <span class="title">排序：</span>
          <div
            class="sort-content"
            :key="index"
            v-for="(item, index) in sortArr"
            @click="changeSort(index)"
          >
            {{ item.title }}
            <span class="el-icon" v-if="activeSort == index">
              <i class="el-icon-back"> </i>
            </span>
            <span class="el-icon-new" v-else>
              <i class="el-icon-back"></i>
            </span>
            <span class="el-border" v-if="index != sortArr.length - 1"></span>
          </div>
        </span>
        <span class="download-wrap" @click="exportFn">
          <img src="../../assets/images/icon_export.png" />
          <span>导出数据</span>
        </span>
      </div>
      <div class="data-table" v-loading="activeLoading">
        <el-table :data="activeData" stripe>
          <el-table-column label="作品名称" prop="name" align="center" fixed>
          </el-table-column>
          <el-table-column label="作品类型" prop="ctype" align="center">
            <template slot-scope="scope">
              <span>
                {{
                  scope.row.ctype === 1
                    ? '地图'
                    : scope.row.ctype === 2
                    ? '游戏'
                    : scope.row.ctype
                }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="审核状态" prop="open_svr" align="center">
          </el-table-column>
          <el-table-column
            label="浏览次数"
            prop="nowview_counts"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="下载次数"
            prop="nowdownload_counts"
            align="center"
          >
          </el-table-column>
          <!-- <el-table-column label="下载人数" prop="count" align="center">
          </el-table-column> -->
          <el-table-column
            label="游戏次数"
            prop="nowplay_counts"
            align="center"
          >
          </el-table-column>
          <!-- 
          <el-table-column label="游戏人数" prop="count" align="center">
          </el-table-column> -->
          <el-table-column
            label="游戏时长（分钟）"
            prop="nowplay_times"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="评论数"
            prop="nowcomment_counts"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="投块数"
            prop="nowreward_counts"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="收藏数"
            prop="nowcollect_counts"
            align="center"
          >
          </el-table-column>
          <el-table-column label="发布时间" prop="create_time" align="center">
          </el-table-column>
          <el-table-column align="center" fixed="right">
            <template slot="header"><span>详情</span> </template>
            <template slot-scope="scope">
              <span class="all-look" @click="mapDetailClick(scope.row.id)">
                查看详情
              </span>
            </template>
          </el-table-column>
          <!-- 无数据的时候 -->
          <template slot="empty">
            <div class="img-no" v-if="showDefault">
              <img
                class="img-no-data"
                src="@/assets/images/img_table_no_data.png"
              />
              <div class="noCart">暂无数据</div>
            </div>
          </template>
        </el-table>
      </div>
      <el-pagination
        background
        @current-change="handleActiveChange"
        :current-page="pageInfo.page"
        :page-size="pageInfo.pageSize"
        layout="prev, pager, next,jumper"
        :total="pageInfo.total"
        hide-on-single-page
      >
      </el-pagination>
    </div>
    <!-- 收入数据 -->
    <div class="work-wrap" v-else>
      <div class="data-filter">
        <span class="mgr25">选择日期</span>
        <el-date-picker
          v-model="incomeDate"
          type="daterange"
          align="left"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          unlink-panels
          range-separator="~"
          :picker-options="pickerOptions"
          value-format="timestamp"
          @change="DateChange"
        >
        </el-date-picker>
        <el-button @click="incomeBtnClicked" class="search_btn" type="info">
          查找
        </el-button>
        <!-- <span class="download-wrap" @click="exportIn">
          <img src="../../assets/images/icon_export.png" />
          <span>导出数据</span>
        </span> -->
      </div>
      <div class="sort-wrap">
        <span class="sort-box">
          <span class="title">排序：</span>
          <div
            class="sort-content"
            :key="index"
            v-for="(item, index) in sortInArr"
            @click="changeInSort(index)"
          >
            {{ item.title }}
            <span class="el-icon" v-if="incomeSort == index">
              <i class="el-icon-back"> </i>
            </span>
            <span class="el-icon-new" v-else>
              <i class="el-icon-back"> </i>
            </span>
            <span class="el-border" v-if="index != sortInArr.length - 1"></span>
          </div>
        </span>
        <span class="download-wrap" @click="exportFn">
          <img src="../../assets/images/icon_export.png" />
          <span>导出数据</span>
        </span>
      </div>
      <!-- <div class="work-list">
        <table class="table-wrap" v-loading="loading">
          <tr class="tr-head">
            <td v-for="(title, index) in tableTitleArr" :key="index">
              <p class="tr-title">
                <span> {{ title.title }}</span>
                <img
                  @click="sortDataType(index)"
                  v-if="title.rank"
                  :class="{ activeSort: tableInfo.sortType == index }"
                  src="@/assets/images/icon_order.png"
                />
              </p>
            </td>
          </tr>
          <tr v-for="table in tableData" :key="table.id">
            <td>{{ table.name }}</td>
            <td>{{ table.today_download }}</td>
            <td>{{ table.yesterday_download }}</td>
            <td>{{ table.yesterday_download }}</td>
            <td>{{ table.yesterday_download }}</td>
            <td>{{ table.total_download }}</td>
            <td>
              {{
                table.yesterday_ad_count == -1 ? '--' : table.yesterday_ad_count
              }}
            </td>
            <td>{{ table.ad_count == -1 ? '--' : table.ad_count }}</td>
            <td>{{ table.time | regroupDate }}</td>
            <td class="btn-detail" @click="mapDetailClick(table.id)">
              查看详情
            </td>
          </tr>
        </table>
        <div class="img-no" v-if="showDefaultImg">
          <div class="img-no-data">
            <img src="@/assets/images/img_table_no_data.png" />
            <p>您暂时还没有数据呢~</p>
          </div>
        </div>
      </div> -->
      <div class="data-table">
        <el-table :data="tableData" stripe>
          <el-table-column label="作品名称" prop="name" align="center" fixed>
          </el-table-column>
          <el-table-column label="迷你豆数量" prop="type" align="center">
          </el-table-column>
          <el-table-column label="迷你点数量" prop="count" align="center">
          </el-table-column>
          <el-table-column label="贡献点数量" prop="count" align="center">
          </el-table-column>
          <el-table-column label="广告收入" align="center">
            <el-table-column label="触发器广告收入" prop="count" align="center">
              <template slot="header">
                <el-tooltip placement="top">
                  <span
                    >触发器收入
                    <img
                      class="icon-help"
                      src="@/assets/images/icon_help.png"
                    />
                  </span>

                  <p slot="content" style="font-size: 16px; color: #fff">
                    在地图作品中，用户通过触发器观看的广告记为内购商店广告，该收入是广告收入的一部分。
                  </p>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="内购商店收入" prop="count" align="center">
              <template slot="header">
                <el-tooltip placement="top">
                  <span
                    >内购商店收入
                    <img
                      class="icon-help"
                      src="@/assets/images/icon_help.png"
                    />
                  </span>

                  <p slot="content" style="font-size: 16px; color: #fff">
                    在地图作品中，用户通过观看开发者商店内商品的广告记为内购商店广告，该收入是广告收入的一部分。
                  </p>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="通行证收入" prop="count" align="center">
              <template slot="header">
                <el-tooltip placement="top">
                  <span
                    >通行证收入
                    <img
                      class="icon-help"
                      src="@/assets/images/icon_help.png"
                    />
                  </span>

                  <p slot="content" style="font-size: 16px; color: #fff">
                    在地图作品中，用户通过观看畅玩通行证的广告记为通行证广告，该收入是广告收入的一部分。
                  </p>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="其他广告收入" prop="count" align="center">
            </el-table-column>
            <el-table-column label="合计" prop="count" align="center">
            </el-table-column>
          </el-table-column>

          <el-table-column label="发布时间" prop="count" align="center">
          </el-table-column>
          <el-table-column align="center">
            <template slot="header"><span>详情</span> </template>
            <template slot-scope="scope">
              <span class="all-look" @click="mapDetailClick(scope.row.id)">
                查看详情
              </span>
            </template>
          </el-table-column>
          <!-- 无数据的时候 -->
          <template slot="empty">
            <div class="img-no" v-if="showDefaultImg">
              <img
                class="img-no-data"
                src="@/assets/images/img_table_no_data.png"
              />
              <div class="noCart">暂无数据</div>
            </div>
          </template>
        </el-table>
      </div>
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page="tableInfo.page"
        :page-size="tableInfo.pageSize"
        layout="prev, pager, next,jumper"
        :total="tableInfo.total"
        hide-on-single-page
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {
  getMapList,
  downloadData,
  getActiveData,
  getMotivate,
} from '@/api/charts';
const ONE_WEEK_TIME = 1000 * 60 * 60 * 24 * 7;
const ONE_DAY_TIME = 24 * 60 * 60 * 1000 - 1;
const ONE_DAY = 24 * 60 * 60 * 1000;
export default {
  data() {
    return {
      loading: false,
      showDefaultImg: false,
      showDefault: false,
      activeLoading: false,
      tabLabel: 1,
      singelData: {},
      productLoading: false,
      startTime: '',
      endTime: '',
      tableDate: [],
      incomeDate: [],
      activeSort: 0,
      range: 2,
      incomeSort: 0,
      dayNum: 7,
      //  showDefaultImg:true,
      tableInfo: {
        page: 1,
        pageSize: 10,
        total: 0,
        sortType: 1,
      },
      pageInfo: {
        page: 1,
        pageSize: 10,
        total: 0,
        sortType: 4,
      },
      brighten: false,
      sortArr: [
        { title: '发布时间' },
        { title: '作品下载总次数' },
        // { title: '游戏总人数' },
        { title: '游戏总时长' },
        { title: '评论数' },
      ],
      sortInArr: [
        { title: '发布时间' },
        { title: '迷你豆数量' },
        { title: '迷你点数量' },
        { title: '贡献点数量' },
        { title: '广告收入' },
      ],
      tableData: [],
      activeData: [],
      tableTitleArr: [
        { title: '作品名称', rank: false },
        { title: '迷你豆数量', rank: true },
        { title: '迷你点数量', rank: true },
        { title: '贡献点数量', rank: true },
        { title: '广告收入', rank: true },
        { title: '触发器广告收入', rank: false },
        { title: '内购商店收入', rank: false },
        { title: '通行证收入', rank: false },
        { title: '发布时间', rank: true },
        // { title: '今日下载(预估)', rank: true },
        // { title: '昨日下载', rank: true },
        // { title: '总下载', rank: true },
        // { title: '昨日广告展示', rank: true },
        // { title: '总广告展示', rank: true },
        // { title: '上传日期', rank: true },

        { title: '详情', rank: false },
      ],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
    };
  },
  watch: {
    'tableInfo.sortType'() {},
    'pageInfo.sortType'() {
      this.fetchActiveData();
    },
    'tableInfo.page'() {},
    tableData(val) {
      this.showDefaultImg = !(val && val.length);
    },
    activeData(val) {
      this.showDefault = !(val && val.length);
    },
  },
  filters: {
    regroupDate(timestamp) {
      let time = new Date(timestamp * 1000);
      let year = time.getFullYear();
      const month = (time.getMonth() + 1).toString().padStart(2, '0');
      const date = time.getDate().toString().padStart(2, '0');
      return year + '-' + month + '-' + date;
    },
  },
  mounted() {
    this.getMotivateData();
    this.init();
    if (this.activeData.length == 0) {
      this.showDefault = true;
    } else {
      this.showDefault = false;
    }
    if (this.tableData.length == 0) {
      this.showDefaultImg = true;
    } else {
      this.showDefaultImg = false;
    }
  },
  created() {
    const currTime = new Date(new Date(new Date()).toDateString()).getTime();
    this.tableDate = [currTime - ONE_WEEK_TIME, currTime - ONE_DAY]; //活跃数据时间
    this.incomeDate = [currTime - ONE_WEEK_TIME, currTime - ONE_DAY];
  },
  methods: {
    sortDataType(index) {
      this.tableInfo.sortType = index;
      this.rankClick(index);
    },
    //获取全地图激励数据
    async getMotivateData() {
      const time = parseInt(new Date().getTime() / 1000);
      let data = {
        time: time,
        range: this.range,
      };
      const res = await getMotivate(data);
      if (res.data.ret === 0) {
        this.singelData = res.data.msg.single;
      }
    },
    regroupFilDate(timestamp) {
      let time = new Date(timestamp * 1000);
      let year = time.getFullYear();
      const month = (time.getMonth() + 1).toString().padStart(2, '0');
      const date = time.getDate().toString().padStart(2, '0');
      return year + '-' + month + '-' + date;
    },
    changeDate() {
      const nowTime = new Date(new Date(new Date()).toDateString()).getTime();
      //判断选择时间是7天/30天/90天
      this.endTime =
        new Date(new Date(new Date()).toDateString()).getTime() - 1;
      this.tableDate[1] = this.endTime - ONE_DAY_TIME;
      if (this.dayNum == 7) {
        this.startTime = nowTime - 7 * 24 * 60 * 60 * 1000;
        this.range = 2;
      } else if (this.dayNum == 30) {
        this.startTime = nowTime - 30 * 24 * 60 * 60 * 1000;
        this.range = 3;
      } else {
        this.startTime = nowTime - 90 * 24 * 60 * 60 * 1000;
        this.range = 4;
      }
      this.tableDate[0] = this.startTime;
      this.getMotivateData();
      this.fetchActiveData();
    },
    async getNActiveData() {
      this.activeLoading = true;
      let data = {
        sort_type: this.pageInfo.sortType,
        page: this.pageInfo.page,
        page_size: this.tableInfo.pageSize,
        start_time: parseInt(this.startTime / 1000, 10),
        end_time: parseInt(this.endTime / 1000, 10),
      };
      try {
        const res = await getActiveData(data);
        if (res.data.list.length) {
          this.activeData = res.data.list.map(item => {
            if (
              item.open_svr === 0 ||
              item.open_svr === 9 ||
              item.open_svr === 1
            ) {
              item.open_svr = '审核中';
            } else if (item.open_svr === 10 || item.open_svr === 13) {
              item.open_svr = '审核成功';
            } else if (
              item.open_svr === 2 ||
              item.open_svr === 3 ||
              item.open_svr === 7 ||
              item.open_svr === 8
            ) {
              item.open_svr = '隐藏';
            } else if (item.open_svr === 4 || item.open_svr === 14) {
              item.open_svr = '封禁';
            }
            item.nowplay_times = (item.nowplay_times / 60).toFixed(2);
            item.create_time = this.regroupFilDate(item.create_time);
            return item;
          });
        }

        this.pageInfo.total = res.data.total_count;
        // this.activeData = [];
        this.activeLoading = false;
      } catch (error) {
        console.log(error);
        this.activeLoading = false;
      }
    },
    BtnClicked() {
      //判断tableDate是否为空
      if (this.tableDate) {
        this.range = 4;
        this.getMotivateData();
        this.brighten = true;
        this.fetchActiveData();

        //this.
      }
    },
    incomeBtnClicked() {
      this.fetchMapList();
    },
    // sortDatactive(index) {
    //   this.pageInfo.sortType = index;
    // },
    changeTab(index) {
      this.tabLabel = index;
    },
    changeSort(index) {
      this.activeSort = index;
      switch (index) {
        case 0:
          this.pageInfo.sortType = 4;
          break;
        case 1:
          this.pageInfo.sortType = 2;
          break;
        case 2:
          this.pageInfo.sortType = 10;
          break;
        case 3:
          this.pageInfo.sortType = 11;
          break;
        default:
          break;
      }
    },
    changeInSort(index) {
      this.incomeSort = index;
    },
    DateChange() {},
    //查看地图详情点击埋点
    mapDetailClick(tid) {
      this.$log('map_details_check_click', 85415, { v7: 1 });
      this.$router.push({ path: '/charts/detail', query: { id: tid } });
    },
    //排序按钮点击埋点
    rankClick(index) {
      this.$log('rank_click', 85414, { v7: 1, v8: index });
    },
    exportFn() {
      this.ActiveExport();
    },
    // exportIn() {
    //   this.fetchExport();
    // },
    //导出收入数据
    // async fetchExport() {
    //   let data = {
    //     start_time: parseInt(this.incomeDate[0] / 1000, 10),
    //     end_time: parseInt((this.incomeDate[1] + ONE_DAY_TIME) / 1000, 10)
    //   };
    //   try {
    //     const res = await downloadData(data);
    //     this.downloadFile(res.data.url);
    //     this.$message.success('下载成功');
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },
    //导出活跃数据
    async ActiveExport() {
      let data = {
        start_time: parseInt(this.tableDate[0] / 1000, 10),
        end_time: parseInt((this.tableDate[1] + ONE_DAY_TIME) / 1000, 10),
      };
      try {
        const res = await downloadData(data);
        this.downloadFile(res.data.url);
        this.$message.success('下载成功');
      } catch (error) {
        console.log(error);
      }
    },
    //下载数据
    downloadFile(url) {
      let a = document.createElement('a');
      a.href = url;
      a.download = url.split('/').pop();
      a.click();
    },
    init() {
      //初始化数据
      //获取活跃数据
      this.fetchActiveData();
      if (this.tableTotal) {
        document.getElementsByClassName(
          'el-pagination__jump',
        )[0].childNodes[0].nodeValue = '跳至';
      }
    },
    // 地图列表-收入数据
    async fetchMapList() {
      this.loading = true;
      let data = {
        sort_type: this.tableInfo.sortType,
        page: this.tableInfo.page,
        page_size: this.tableInfo.pageSize,
        start_time: parseInt(this.tableDate[0] / 1000, 10),
        end_time: parseInt((this.tableDate[1] + ONE_DAY_TIME) / 1000, 10),
      };
      try {
        const res = await getMapList(data);
        this.tableData = res.data.list;
        this.tableInfo.total = res.data.total_count;
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },
    //作品列表-活跃数据
    async fetchActiveData() {
      this.activeLoading = true;
      let data = {
        sort_type: this.pageInfo.sortType,
        page: this.pageInfo.page,
        page_size: this.tableInfo.pageSize,
        start_time: parseInt(this.tableDate[0] / 1000, 10),
        end_time: parseInt((this.tableDate[1] + ONE_DAY_TIME) / 1000, 10),
      };
      try {
        const res = await getActiveData(data);
        if (res.data.list.length) {
          this.activeData = res.data.list.map(item => {
            if (
              item.open_svr === 0 ||
              item.open_svr === 9 ||
              item.open_svr === 1
            ) {
              item.open_svr = '审核中';
            } else if (item.open_svr === 10 || item.open_svr === 13) {
              item.open_svr = '审核成功';
            } else if (
              item.open_svr === 2 ||
              item.open_svr === 3 ||
              item.open_svr === 7 ||
              item.open_svr === 8
            ) {
              item.open_svr = '隐藏';
            } else if (item.open_svr === 4 || item.open_svr === 14) {
              item.open_svr = '封禁';
            } else if (item.open_svr === 17) {
              item.open_svr = '上传成功';
            }
            if (
              Object.prototype.hasOwnProperty.call(this.singelData, item.id)
            ) {
              let obj = this.singelData[item.id];
              // item.nowcollect_counts =
              //   (obj.collect | 0) + item.nowcollect_counts;
              item.nowdownload_counts =
                (obj.download | 0) + item.nowdownload_counts;
              item.nowplay_counts = (obj.play_count | 0) + item.nowplay_counts;
              item.nowplay_times = (obj.play_time | 0) + item.nowplay_times;
              item.nowview_counts = (obj.browse | 0) + item.nowview_counts;
            }
            item.create_time = this.regroupFilDate(item.create_time);
            item.nowplay_times = (item.nowplay_times / 60).toFixed(2);
            //添加激励数据
            return item;
          });
        }

        this.pageInfo.total = res.data.total_count;
        // this.activeData = [];
        this.activeLoading = false;
        this.brighten = false;
      } catch (error) {
        console.log(error);
        this.activeLoading = false;
      }
    },
    handleActiveChange(val) {
      this.pageInfo.page = val;
      this.fetchActiveData();
    },
    handleCurrentChange(val) {
      this.tableInfo.page = val;
      // this.fetchMapList();
    },
    // cellStyle(column) {
    //   let cellStyle;
    //   if (column.columnIndex === 10) {
    //     cellStyle = 'padding:0;background:red';
    //   }
    //   return cellStyle;
    // }
  },
};
</script>

<style lang="scss" scoped>
$--color-primary: #fd9b21;
.block {
  .title {
    font-size: 20px;
    color: #262626;
    margin-top: -5px;
  }
  // .work-wrap {
  //   margin-left: 17px;
  // }
  .date-box {
    display: flex;
    .date-wrap {
      padding-top: 10px;
      margin-left: 15px;
    }
  }
  .data-filter {
    margin-top: 10px;
    margin-bottom: 10px;
    .mgr25 {
      margin-right: 25px;
    }
    .search_btn {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      border-left: 0;
      color: #595959;
      border-right: 1px solid #d9d9d9;
      border-top: 1px solid #d9d9d9;
      border-bottom: 1px solid #d9d9d9;
      background-color: #f4f4f5;
    }
    .active.search_btn {
      background: #fd9b21;
    }
  }
  .sort-wrap {
    display: flex;
    .title {
      font-size: 14px;
      margin-top: 0;
    }
    .el-icon {
      .el-icon-back {
        transform: rotate(-90deg);
      }
    }
    .el-icon-new {
      opacity: 0;
    }
    .sort-content {
      margin-right: 5px;
      cursor: pointer;
      .el-border {
        border-right: 2px solid #d8d8d8;
        margin-right: 4px;
      }
    }
    .sort-box {
      display: flex;
      width: 92%;
    }
    .download-wrap {
      //float: right;
      //display: block;
      //margin-right: 150px;
      border-radius: 4px;
      font-size: 11px;
      //background-color: #595959;
      // font-weight: 600;
      //margin-top: 13px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      cursor: pointer;
      color: #2b6ddf;
      img {
        margin-right: 8px;
      }
    }
  }
  .data-table {
    margin-top: 16px;
    border: 1px solid #d9d9d9;
    overflow: hidden;
    border-radius: 3px;
    ::v-deep .el-table tr:last-child td {
      border-bottom: none;
    }
    ::v-deep .el-table::before {
      background: transparent;
    }
    ::v-deep .el-table th {
      background: #fafafa;
      line-height: 29px;
    }
    ::v-deep .el-table td {
      line-height: 29px;
      padding: 7px 0 6px;
    }
    ::v-deep.el-table .cell {
      padding: 0 5px;
    }
    .img-no {
      margin: 20px auto 10px auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .img-no-data-word {
        margin: 10px auto;
      }
    }
    ::v-deep .el-table__empty-text {
      line-height: 30px;
      margin-bottom: 15px;
      margin-top: 15px;
    }
    .all-look {
      color: #2b6ddf;
      // text-decoration: underline;

      display: flex;
      cursor: pointer;
      justify-content: center;
    }
    img.icon-help {
      height: 10px;
      width: 10px;
    }
  }
  #tab {
    //margin: 10px auto 18px 0;
    margin: 10px auto 5px 0;
    font-size: 16px;
    // margin-left: 17px;
    display: flex;
    .tab-btn {
      //margin-right: 20px;
      padding-bottom: 10px;
      font-size: 24px;
      //cursor: pointer;
    }
    .tab-btn.active {
      border-bottom: 3px solid #fd9b21;
    }
    .tab-income {
      padding-bottom: 10px;
      cursor: pointer;
    }
    .tab-income.active {
      border-bottom: 3px solid #fd9b21;
    }
    .list-border {
      border-right: 3px solid #dcdcdc;
      margin: 2px 15px 7px 15px;
    }
  }
}
.work-list {
  margin-top: 20px;
  // margin-left: 20px;
  border: 1px solid #d9d9d9;
  .btn-detail {
    color: #2b6ddf;
    cursor: pointer;
  }
}
.el-pagination {
  text-align: center;
  margin-top: 19px;
}

::v-deep {
  .el-pagination.is-background .el-pager li,
  .el-pagination.is-background button {
    width: 32px;
    height: 32px;
    line-height: 32px;
  }
  .el-pagination.is-background .el-input__inner {
    height: 32px;
    line-height: 32px;
  }
  .el-pagination.is-background .el-pager li:not(.disabled) {
    background-color: #fff;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    color: $--color-primary;
    border: 1px solid #ffc973;
    background: #fffaed;
    border-radius: 4px;
  }
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .btn-next {
    background-color: #fff;

    border-radius: 4px;
    border: 1px solid #d9d9d9;
  }
}
.table-wrap {
  width: 100%;
  .tr-title {
    display: flex;
    align-items: center;
    img {
      margin-left: 3px;
      cursor: pointer;
      width: 15px;
      height: 14px;
      margin-top: -1px;
    }
    .activeSort {
      cursor: text;
    }
  }
  .btn-detail {
    color: #2b6ddf;
    cursor: pointer;
  }
}

tr:nth-child(even) {
  background: #fafafa;
}
.tr-head {
  background: #fafafa;
  border-bottom: 1px solid #d9d9d9;
}
td {
  padding: 10px;
  text-align: left;
  max-width: 225px;
  word-wrap: break-word; //文本换行
  vertical-align: middle;
}
.img-no {
  margin: 20px auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .img-no-data-word {
    margin: 10px auto;
  }
}
</style>
